import {
  AUTH_GET_PERMISSIONS,
  AUTH_LOGIN,
  AUTH_LOGOUT,
  AUTH_ERROR,
  AUTH_CHECK
} from "react-admin";

const API_AUTH = process.env.BE_API_AUTH;

const APP_NAME = process.env.APP_NAME;

// Authenticatd by default
export default (type, params) => {
  if (type === AUTH_LOGIN) {
    const { username, password } = params;
    const formData = {
      user: username,
      password: password,
      companyVatId: "76654150-K"
    };

    // fetch login
    return fetch(API_AUTH + "login", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(formData)
    })
      .then(response => {
        if (response.status < 200 || response.status >= 300) {
          throw new Error(response.statusText);
        }
        return response.json();
      })
      .then(({ token }) => {
        if (token) {
          // session user login
          localStorage.setItem(APP_NAME + "token", token);
          localStorage.setItem("not_authenticated", false);
        } else {
          throw new Error();
        }
      });
  }
  if (type === AUTH_LOGOUT) {
    if (localStorage.getItem(APP_NAME + "token")) {
      const token = localStorage.getItem(APP_NAME + "token");

      const requestRevoke = new Request(API_AUTH + "logout", {
        method: "GET",
        headers: new Headers({
          "Content-Type": "application/json",
          token: token
        })
      });
      localStorage.removeItem(APP_NAME + "token");
      localStorage.removeItem("access");
      localStorage.setItem("not_authenticated", true);
      return fetch(requestRevoke);
    }
    return;
  }
  if (type === AUTH_ERROR) {
    if (localStorage.getItem("not_authenticated")) {
      return Promise.reject();
    }
    return Promise.resolve();
  }
  if (type === AUTH_CHECK) {
    return localStorage.getItem(APP_NAME + "token")
      ? Promise.resolve()
      : Promise.reject();
  }
  if (type === AUTH_GET_PERMISSIONS) {
    return localStorage.getItem(APP_NAME + "token")
      ? Promise.resolve()
      : Promise.reject();
  }
  return Promise.reject("Unknown method");
};
